// image animation css
let lastScrollTop = 0; // Keeps track of the previous scroll position

window.addEventListener("scroll", function () {
  const currentScrollTop = document.documentElement.scrollTop;
  const images = document.querySelectorAll(".scrollImage");
  const smimages = document.querySelectorAll(".sm-scrollImage");
  const bgImages = document.querySelectorAll(".bg-scrollImage");

  images.forEach((image) => {
    if (currentScrollTop > lastScrollTop) {
      // Scrolling down
      image.style.transform = "translateY(-20px)"; // Moves image up
    } else {
      // Scrolling up
      image.style.transform = "translateY(20px)"; // Moves image down
    }
  });

  smimages.forEach((image) => {
    if (currentScrollTop > lastScrollTop) {
      // Scrolling down
      image.style.transform = "translateX(-10px)"; // Moves image up
    } else {
      // Scrolling up
      image.style.transform = "translateX(10px)"; // Moves image down
    }
  });

  bgImages.forEach((bgImage) => {
    if (currentScrollTop > lastScrollTop) {
      // Scrolling down
      bgImage.style.backgroundPosition = "bottom top"; // Moves background up
    } else {
      // Scrolling up
      bgImage.style.backgroundPosition = "center bottom"; // Moves background down
    }
  });

  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Avoids negative values
});

// image animation css

// header color change

let lastScrollPosition = 0; // Track the last scroll position

window.addEventListener("scroll", function () {
  const currentScrollPosition = window.scrollY;
  const pageHeight = document.documentElement.scrollHeight; // Total page height
  const triggerHeight = pageHeight * 0.2; // 20% of page height

  const headers = document.querySelectorAll(
    ".m-header_desktop, .m-header_mobile"
  ); // Header element
  const menus = document.querySelectorAll(".m-menu__link--main"); // Select all menu elements

  // Change headers' background color based on scroll position
  headers.forEach((header) => {
    if (currentScrollPosition > triggerHeight) {
      header.classList.add("change-color", "another-class"); // Add multiple classes
      header.style.willChange = "background-color"; // Hint for performance
    } else {
      header.classList.remove("change-color", "another-class"); // Remove multiple classes
      header.style.willChange = ""; // Remove hint
    }
  });

  // Hide/show all menus based on scroll direction
  menus.forEach((menu) => {
    if (currentScrollPosition > lastScrollPosition) {
      // Scrolling down
      menu.style.opacity = "1"; // Fade out menu
      menu.style.pointerEvents = "auto"; // Prevent interaction when hidden
    } else {
      // Scrolling up
      menu.style.opacity = "1"; // Fade in menu
      menu.style.pointerEvents = "auto"; // Allow interaction when visible
    }
  });

  // Update last scroll position
  lastScrollPosition = currentScrollPosition;
});

// header color change

// New Aimation
